import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { QuestUserInfoResponse } from '@kanji/types';

interface AuthState {
  token: string | null;
  user: QuestUserInfoResponse | null;
  isLoading: boolean;
  error: string | null;
  setAuth: (token: string, user: QuestUserInfoResponse) => void;
  logout: () => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      isLoading: false,
      error: null,
      setAuth: (token, user) => set({ token, user, error: null }),
      logout: () => set({ token: null, user: null }),
      setLoading: (isLoading) => set({ isLoading }),
      setError: (error) => set({ error }),
    }),
    {
      name: 'kanji-auth',
      partialize: (state) => ({ token: state.token, user: state.user }),
    }
  )
);
